import './video.css';

import jafara from '../../../photos/Video/uflebebi.png';

import mzia from '../../../photos/Video/mzia.png';
import qselurimagaziebi from '../../../photos/Video/qselurimagaziebi.png';

// import { SeeAllButton  } from '../../../components/seeallbutton/SeeAll';

const videoList = [
    { src: qselurimagaziebi, title: "Reed More", link: "https://www.facebook.com/watch/?v=269367012333699" },
    { src: mzia, title: "Read More", link: "https://monitori.ge/mzia-amaghlobelis-ukanono-administraciuli-dakavebis-mtkicebulebebi/" },
    { src: jafara, title: "Read More", link: "https://youtu.be/GTz3_Xz_PTU?si=zJAFTUVU4wwpAnoO" },
]

export function Video() {
    return (

        <div className="video-zipotela">
            <div className="video div">
                <h4 className="video-title title">Video Reportage</h4>
                <div className="video-content content">
                    {
                        videoList.map((videoLists, index) => (
                            <div className="video-lists lists">
                                <div className="video-img lists-img-div">
                                    <img src={videoLists.src} alt="" />
                                </div>
                                <div className='video-lists-title lists-title'>
                                    <h4>
                                        <a href={videoLists.link} target="_blank" rel="noopener noreferrer">
                                            {videoLists.title} &#8811;
                                        </a>
                                    </h4>
                                </div>

                            </div>
                        ))
                    }
                </div>
                {/* <SeeAllButton /> */}
            </div>
        </div>

    )
}